function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icon-pencil");

var SvgIconPencil = function SvgIconPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 244.02 238.49",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M217.9,15,229,26.11a35.45,35.45,0,0,1,0,50.13L85.16,220.12,6.08,232.85l17.82-74L167.78,15A35.42,35.42,0,0,1,217.9,15Z",
    style: {
      fill: "none",
      stroke: "#54585A",
      strokeMiterlimit: 10,
      strokeWidth: "9.18903958797455px",
      fillRule: "evenodd"
    }
  }), React.createElement("line", {
    x1: 31.09,
    y1: 157.15,
    x2: 88.94,
    y2: 211.34,
    style: {
      fill: "none",
      stroke: "#54585A",
      strokeMiterlimit: 10,
      strokeWidth: "5.25087976455689px"
    }
  }), React.createElement("line", {
    x1: 161.32,
    y1: 26.25,
    x2: 219.17,
    y2: 80.44,
    style: {
      fill: "none",
      stroke: "#54585A",
      strokeMiterlimit: 10,
      strokeWidth: "5.25087976455689px"
    }
  }), React.createElement("polygon", {
    points: "9.62 231.65 30.51 228.31 14.06 211.38 9.62 231.65",
    style: {
      fill: "#54585A",
      fillRule: "evenodd"
    }
  }), React.createElement("line", {
    x1: 45.4,
    y1: 170.38,
    x2: 177.66,
    y2: 40.39,
    style: {
      fill: "none",
      stroke: "#54585A",
      strokeMiterlimit: 10,
      strokeWidth: "5.25087976455689px"
    }
  }), React.createElement("line", {
    x1: 72.05,
    y1: 196.93,
    x2: 204.32,
    y2: 66.95,
    style: {
      fill: "none",
      stroke: "#54585A",
      strokeMiterlimit: 10,
      strokeWidth: "5.25087976455689px"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-pencil.d30ad4a2.svg";
export { ForwardRef as ReactComponent };